// Native
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit, Output,
  Renderer2,
  ViewChild
} from '@angular/core'

// Imported
import * as moment from 'moment';
import {DaterangepickerConfig} from 'ng2-daterangepicker';

// Services
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {IDateRange} from "../../../interfaces/date-range";
import {Moment} from "moment";
import {MomentPipe} from "../../pipes/moment-pipe/moment.pipe"; // Даты

@Component({
  selector: 'daterange-picker',
  templateUrl: './daterange-picker.component.html',
  providers: [
    DaterangepickerConfig,
    MomentPipe,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DaterangePickerComponent),
      multi: true,
    },
  ],
})
export class DaterangePickerComponent implements OnInit, ControlValueAccessor {
  // TODO has bug, when not single... select all text of input and remove, run selectedDate;

  @ViewChild('input', {static: true}) inputEl: ElementRef;

  @Input() after: boolean;
  @Input() before: boolean;
  @Input() placeholder: string;
  @Input() start: any;
  @Input() end: any;
  @Input() single: boolean;
  @Input() clearable: boolean;
  @Input() daysBeforeNow: number;
  @Input() default: boolean;

  textValueHidden: boolean = false;
  @Input('textValueHidden') set textValueHidden$(value: any) {
    if (value) {
      this.textValueHidden = true
    } else {
      this.textValueHidden = false;
      this.parserValue();
    }
  }
  @Input() tableFilter: boolean = false;
  @Input() cancelButton = false;

  @Input() disabled: boolean;

  @Output() init: EventEmitter<null | Date | IDateRange> = new EventEmitter<null | Date | IDateRange>();
  @Output() change: EventEmitter<null | Date | IDateRange> = new EventEmitter<null | Date | IDateRange>();

  textValue: string = '';
  localeValue: null | Moment | {
    start: null | Moment;
    end: null | Moment;
  };

  constructor(private _changeDetectorRef: ChangeDetectorRef,
              private dateRangePickerConfig: DaterangepickerConfig,
              private renderer: Renderer2,
              private momentPipe: MomentPipe) {
  }

  ngOnInit() {
    this.setOptions();
    this.setDefaultValues();

    if (this.default) {
      setTimeout(() => {
        this.onChange(this.parserDate());
        this.init.emit(this.parserDate());
      });
    }
  }

  private onTouched = () => {};

  private onChange: (value: null | Date | IDateRange) => void = () => {};

  registerOnChange(onChange: (value: null | Date | IDateRange) => void) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: () => void) {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;

    this._changeDetectorRef.detectChanges();
  }

  writeValue(value: Date | IDateRange) {
    if (!value && !this.tableFilter) return;

    if (value instanceof Date) {
      this.localeValue = this.single ? moment(value) : {
        start: moment(value),
        end: moment(value),
      };
    } else {
      this.localeValue = this.single ? moment(value?.start) : {
        start: moment(value?.start),
        end: moment(value?.end),
      };
    }


    this.parserValue();
    this.updateDate();
  }

  selectedDate(value: any) {
    this.localeValue = this.single ? moment(value?.start) : {
      start: moment(value?.start),
      end: moment(value?.end),
    };

    this.parserValue();
  }

  applyDate() {
    this.onChange(this.parserDate());
    this.change.emit(this.parserDate());
  }
  cancelDate() {
    this.localeValue = null;
    this.parserValue();
    this.applyDate();
  }

  changeDate({target}) {
    this.onTouched();

    // TODO has bug, when not single... select all text of input and remove, run selectedDate;
    if (this.clearable && !target.value) {
      this.localeValue = this.single ? null : {
        start: null,
        end: null,
      };

      this.applyDate();
      this.dateRangePickerConfig.settings.startDate = moment();
      this.dateRangePickerConfig.settings.endDate = moment();
    } else {
      this.parserValue();
    }
  }

  updateDate() {
    if (this.single) {
      this.dateRangePickerConfig.settings.startDate = this.localeValue;
    } else {
      this.dateRangePickerConfig.settings.startDate = this.localeValue['start'];
      this.dateRangePickerConfig.settings.endDate = this.localeValue['end'];
    }
  }

  setOptions() {
    this.dateRangePickerConfig.settings = {
      parentEl: "main",
      singleDatePicker: this.single,
      autoApply: !this.cancelButton,
      autoUpdateInput: false,
      locale: {
        format: 'DD.MM.YYYY',
        applyLabel: 'Apply',
        cancelLabel: 'Clear'
      },
      alwaysShowCalendars: true,
      showCustomRangeLabel: false,
      applyClass: "btn-secondary",
      cancelClass: "btn-outline-info",
      buttonClasses: "btn",
      opens: "right",
    };
  }

  setDefaultValues() {
    if (this.after)
      this.dateRangePickerConfig.settings.minDate = moment();

    if (this.before)
      this.dateRangePickerConfig.settings.maxDate = moment();

    if (this.default) {
      if (this.single) {
        this.localeValue = moment();
      } else {
        this.localeValue = {
          start: moment(),
          end: moment().add(30, 'days'),
        };

        if(this.end && this.end.isBefore(moment())) {
          this.localeValue.end = moment(this.end);
        }

        if(this.start && this.start.isBefore(this.localeValue.end)) {
          this.localeValue.start = moment(this.start);
        }

        this.dateRangePickerConfig.settings.ranges = this.ranges();
        this.dateRangePickerConfig.settings.autoApply = false;
      }

      if (this.daysBeforeNow) {
        const dateBeforeNow = moment().subtract(this.daysBeforeNow, 'days');
        this.localeValue = this.single ? dateBeforeNow : {
          start: dateBeforeNow,
          end: moment(),
        };
      }

      this.parserValue();
      this.updateDate();
    }
  }

  ranges(single: boolean = false) {
    return {
      ['Next week']: [moment(), moment().add(7, 'day')],
      ['Next months']: [moment(), moment().add(1, 'month')],
      [`Next ${single ? '3' : 'three'} months`]: [moment(), moment().add(3, 'month')],
      [`Next ${single ? '6' : 'six'} months`]: [moment(), moment().add(6, 'month')]
    };
  }

  parserValue(): void {
    if (this.localeValue) {
      if (this.single) {
        this.textValue = this.momentPipe.transform(this.localeValue, 'dmy');
      } else if (this.localeValue['start'] && this.localeValue['end']) {
        const startDate = this.momentPipe.transform(this.localeValue['start'], 'dmy');
        const endDate = this.momentPipe.transform(this.localeValue['end'], 'dmy');
        this.textValue = `${startDate} — ${endDate}`;
      }
    } else {
      this.textValue = '';
    }

    if (!this.textValueHidden) {
      this.renderer.setProperty(this.inputEl.nativeElement, 'value', this.textValue);
    }
  }

  parserDate(): Date | IDateRange {
    return this.localeValue ?
      this.single ?
        (this.localeValue ? new Date(this.localeValue as unknown as Date) : null)
        : {
          start: this.localeValue['start'] ? new Date(this.localeValue['start'] as unknown as Date) : null,
          end: this.localeValue['end'] ? new Date(this.localeValue['end'] as unknown as Date) : null,
        }
      : null;
  };

}
